import { readonly, ref } from 'vue';

interface ToastState {
  message: string;
  error: boolean;
  visible: boolean;
}

const state = ref<ToastState>({ message: '', error: false, visible: false });
let timer: ReturnType<typeof setTimeout> | undefined;

/**
 * App-wide toast. A single <AppToast> (mounted in MainLayout) renders
 * `state`; anywhere else calls `toast(msg)` / `toast(msg, true)` for errors.
 */
export function useToast() {
  const toast = (message: string, error = false): void => {
    state.value = { message, error, visible: true };
    clearTimeout(timer);
    timer = setTimeout(() => {
      state.value = { ...state.value, visible: false };
    }, 2600);
  };

  return { state: readonly(state), toast };
}
